import { withStyles } from '@/components/Buttons/Core/withStyles';
import { BaseButton } from '@/components/Buttons/Core/BaseButton';

export const LightButton = withStyles(BaseButton, {
    light: 'muted.50',
    dark: 'muted.800',
    
    textStyle: {
        light: 'muted.900',
        dark: 'muted.100',
    }
});